import { base } from "@base-provider";

export const getGridData = async (url, urlData) => {
  return base.post({ url: url, data: urlData });
};

export const getGridFilterValues = async (url, urlData) => {
  return base.post({ url: url, data: urlData });
};

export const exportGridData = async (url, data, fileName) => {
  base.exportFile({ url, data, fileName });
};
